import React from "react";
import CryptoJS from "crypto-js";
import Assignment from "@material-ui/icons/Assignment";
import GridContainer from "components/Grid/GridContainer.jsx";
//import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import ReactTable from "react-table";
import CardBody from "components/Card/CardBody.jsx";
import { PulseLoader } from "react-spinners";
import API from "@aws-amplify/api";
import withStyles from "@material-ui/core/styles/withStyles";
import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Cookies from "universal-cookie";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "components/CustomButtons/Button.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import LoadingOverlay from "react-loading-overlay";
import { css } from "react-emotion";
import "assets/scss/styles.css";
import SweetAlert from "react-bootstrap-sweetalert";
import Switch from "@material-ui/core/Switch";
import Datetime from "react-datetime";
import { yellow } from "@material-ui/core/colors";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Select from "react-select";
import FormControl from "@material-ui/core/FormControl";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Slide from "@material-ui/core/Slide";
import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";
import PropTypes from "prop-types";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import CronBuilder from "react-cron-builder";
import "react-cron-builder/dist/bundle.css";
import cronstrue from "cronstrue";
import moment from "moment";
import { spendgoOffercode } from "../../util/client-specific/spendgo-offercode";

function Transition(props) {
  return <Slide direction="down" {...props} />;
}
let apiName = process.env.REACT_APP_AMPLIFY_API;
var yesterday = Datetime.moment().subtract(1, "day");
let dateValid = function(current) {
  return current.isAfter(yesterday);
};

// ===================== EDIT CAMPAIGN STATIC VARS
const resetCampaign = { 
  campaignModal: false, 
  editCurrentCampaign: false, 
  campaignName:'', 
  campaignDescription:'', 
  campaignEpochEnds:parseInt(new Date().getTime() / 1000), 
  campaignEpochStarts:parseInt(new Date().getTime() / 1000),
  campaignStartDateErrorText: "",
  campaignEndDateErrorText: "",
}

// ===================== EDIT CAMPAIGN STATIC VARS

class ViewAutomations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      recurringValue: "0 6 * * *",
      recurring: false,
      allTemplates: [],
      exportDisable: false,
      loading: true,
      automationData: [],
      automationId: "",
      alert: null,
      audiencesDropDown: [],
      automationDropSelection: [],
      selectedAudience: "",
      selectedChannelId: "",
      selectedChannelType: "",
      selectedChannelActionId: "",
      campaignName: "",
      campaignDescription: "",
      deploymentModal: false,
      seedListModal: false,
      campaignModal: false,
      editCurrentCampaign: false,
      deploymentName: "",
      selectedTypeInputfields: [],
      channelTypesDropSelection: [],
      campaignDropdown: [],
      allCampaigns:[],
      errors: {},
      error: false,
      channeltypeerror: false,
      exInputFieldserror: false,
      campaignerror: false,
      campaignEpochEnds: new Date().getTime() / 1000,
      campaignEpochStarts: new Date().getTime() / 1000,
      campaignStartDateErrorText: "",
      campaignEndDateErrorText: "",
      automationTimestamp: 0,
      selectedCampaign: "",
      channelParameters: {},
      fullAudienceArray: {},
      // ******************************************* Changes made for Goodwill Offer Code Begin
      offerCodeModal: false,
      localStorageClientId: "",
      offerCodeValue: "",
      durationValue: "",
      // ******************************************* Changes made for Goodwill Offer Code End
      preclubFlag: false,
      clientSeedListSwitchStatus: false,
      showOrHideClientSeedListSwitch: "none",
      seedListOptionsArray: [
        {
          value: "client_seed_list",
          label: "Client Seed List",
        },
        {
          value: "validity",
          label: "Validity",
        },
        {
          value: "email_on_acid_creative",
          label: "Email On Acid (Creative)",
        },
        {
          value: "email_on_acid_deliverability",
          label: "Email On Acid (Deliverability)",
        },
        {
          value: "mail_tester",
          label: "Mail-Tester",
        },
        {
          value: "internal_seed_list",
          label: "Internal Seed List",
        },
      ],
      seedListSelectedOptionsArray: [],
      clientSeedList: false,
      emailOnAcidCreative: false,
      emailOnAcidDeliverability: false,
      validity: false,
      mailTester: false,
      internalSeedList: false,
      audienceSegmentInput: "",
      singleEmailAddressInput: "",
      seedListDeployStatus: false,
      seedListDeployStatusColor: "success",
      seedListDeployStatusMessage: "Seed List Deployed Successfully",
      seedListDeploySummary: false,
      friendlyFromDropdownSelection: [
        {
          value: "Bristol Seafood + Steak + Social",
          label: "Bristol Seafood + Steak + Social",
        },
        {
          value: "Bristol Seafood Grill",
          label: "Bristol Seafood Grill",
        },
        {
          value: "Devon Seafood + Steak",
          label: "Devon Seafood + Steak",
        },
        {
          value: "Devon Seafood Grill",
          label: "Devon Seafood Grill",
        },
        {
          value: "Seafood Grill",
          label: "Seafood Grill"
        },
      ],
      selectedFriendlyFromOption: "",
      friendlyFromOptionError: false,
    };
    // ******************************************* Changes made for Goodwill Offer Code Begin
    this.handleOfferCodeChange = this.handleOfferCodeChange.bind(this);
    this.handleDurationChange = this.handleDurationChange.bind(this);
    // ******************************************* Changes made for Goodwill Offer Code End
  }
  setChecked(e, autoId) {
    fetch(
      "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/automations",
      {
        method: "get",
        headers: { id: autoId },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        if ("Items" in result) {
          if (result["Items"].length > 0) {
            let selectedAid = result["Items"][0];
            selectedAid["active"] = e;
            fetch(
              "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/automations",
              {
                method: "post",
                body: JSON.stringify(selectedAid),
              }
            )
              .then((res) => res.json())
              .then((result) => {
                this.fetchAllAutomations();
              });
          }
        }
      });
  }
  handleClose(modal) {
    var x = [];
    x[modal] = false;
    this.setState(x);
    this.setState({ deploymentName: "" });
    this.setState({ selectedChannelType: "" });
    this.setState({ selectedChannel: "" });
    this.setState({ automationTimestamp: 0 });
  }
  togglePreclubFlagStatus(event) {
    this.setState({ preclubFlag: event });
  }
  deploymentDate(event) {
    let tt = Date.parse(Datetime.moment(event.target.value).format()) / 1000;
    this.setState({ automationTimestamp: tt });
  }
  campaignStartDate(event) {
    let tt = Date.parse(Datetime.moment(event.target.value).format()) / 1000;
    if(!this.state.editCurrentCampaign) {
      this.setState({ campaignStartDateErrorText: tt <= this.state.automationTimestamp ? "Campaign must start after the automation action date": "" });
    }
    else {
      this.setState({ campaignStartDateErrorText: "" });  
    }
    this.setState({ campaignEpochStarts: tt });
  }
  campaignEndDate(event) {
    let tt = Date.parse(Datetime.moment(event.target.value).format()) / 1000;
    if(!this.state.editCurrentCampaign) {
      this.setState({ campaignEndDateErrorText: tt <= this.state.automationTimestamp ? "Campaign must end after the automation action date": "" });
    }
    else {
      this.setState({ campaignStartDateErrorText: "" });  
    }
    this.setState({ campaignEpochEnds: tt });
  }
  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  handleAudienceSegmentInputChange = (event) => {
    this.setState({ audienceSegmentInput: event.target.value });
  };

  handleSingleEmailAddressInputChange = (event) => {
    this.setState({ singleEmailAddressInput: event.target.value });
  };

  handleSeedListOptionsChange = (option) => {
    let selectedOptionsArray = [];
    this.setState(
      (state) => {
        return {
          seedListSelectedOptionsArray: option,
        };
      },
      () => {
        selectedOptionsArray = this.state.seedListSelectedOptionsArray.map(
          (option) => option.value
        );

        if (selectedOptionsArray.includes("client_seed_list")) {
          this.setState({
            clientSeedList: true,
          });
        } else {
          this.setState({
            clientSeedList: false,
          });
        }

        if (selectedOptionsArray.includes("validity")) {
          this.setState({
            validity: true,
          });
        } else {
          this.setState({
            validity: false,
          });
        }
        if (selectedOptionsArray.includes("email_on_acid_creative")) {
          this.setState({
            emailOnAcidCreative: true,
          });
        } else {
          this.setState({
            emailOnAcidCreative: false,
          });
        }
        if (selectedOptionsArray.includes("email_on_acid_deliverability")) {
          this.setState({
            emailOnAcidDeliverability: true,
          });
        } else {
          this.setState({
            emailOnAcidDeliverability: false,
          });
        }
        if (selectedOptionsArray.includes("mail_tester")) {
          this.setState({
            mailTester: true,
          });
        } else {
          this.setState({
            mailTester: false,
          });
        }
        if (selectedOptionsArray.includes("internal_seed_list")) {
          this.setState({
            internalSeedList: true,
          });
        } else {
          this.setState({
            internalSeedList: false,
          });
        }
      }
    );
  };

  deploySeedListOptions = () => {
    if (this.state.singleEmailAddressInput.trim() !== "") {
      this.sendSeedListData();
    } else if (
      Array.isArray(this.state.seedListSelectedOptionsArray) &&
      !this.state.seedListSelectedOptionsArray.length
    ) {
      let err = {};
      err["selectSeedList"] =
        "Please select atleast one option or enter the single email address";
      this.setState({ errors: err }, () => {
        setTimeout(
          function() {
            this.setState({
              errors: (err["selectSeedList"] = ""),
            });
          }.bind(this),
          3000
        );
      });
      return;
    } else {
      this.sendSeedListData();
    }
  };

  sendSeedListData = () => {
    this.setState({ seedListDeploySummary: true });
    fetch(
      "https://ilc5quwtcartput7cvycdmfsty0kxxlg.lambda-url.us-west-2.on.aws/",
      {
        method: "POST",
        body: JSON.stringify({
          automation_id: this.state.automationId,
          client_id: this.state.localStorageClientId,
          client_seedlist: this.state.clientSeedList,
          emailonacid_creative: this.state.emailOnAcidCreative,
          emailonacid_deliverability: this.state.emailOnAcidDeliverability,
          validity: this.state.validity,
          mail_tester: this.state.mailTester,
          internal_seed_list: this.state.internalSeedList,
          audience_segment: this.state.audienceSegmentInput,
          single_email_address: this.state.singleEmailAddressInput,
        }),
      }
    )
      .then((res) => res.json())
      .then((result) => {
        console.log("Result", result);
        if (result.message === "success") {
          this.setState({ seedListDeployStatusColor: "success" });
          this.setState({
            seedListDeployStatusMessage: "Seed List Deployed Successfully",
          });
          this.showSeedListSnackbar();
        } else {
          this.setState({ seedListDeployStatusColor: "danger" });
          this.setState({
            seedListDeployStatusMessage: "Seed List Deployment Failed",
          });
          this.showSeedListSnackbar();
        }
      })
      .catch((err) => {
        this.setState({ seedListDeployStatusColor: "warning" });
        this.setState({
          seedListDeployStatusMessage: "There was an error. Please try again.",
        });
        this.showSeedListSnackbar();
      });
  };
  showSeedListSnackbar = () => {
    this.setState({ seedListDeploySummary: false });
    this.setState({ seedListModal: false });
    this.setState({ seedListDeployStatus: true }, () => {
      setTimeout(
        function() {
          this.setState({
            seedListDeployStatus: false,
          });
        }.bind(this),
        3000
      );
    });
    this.resetClientSeedListModalFields();
  };
  resetClientSeedListModalFields = () => {
    this.setState({
      clientSeedList: false,
      emailOnAcidCreative: false,
      emailOnAcidDeliverability: false,
      validity: false,
      mailTester: false,
      internalSeedList: false,
      audienceSegmentInput: "",
      singleEmailAddressInput: "",
      seedListSelectedOptionsArray: [],
    });
  };

  switchClientSeedListStatus = (e) => {
    this.setState({ clientSeedListSwitchStatus: e });
  };

  // ******************************************* Changes made for Goodwill Offer Code Begin
  handleOfferCodeChange = (event) => {
    this.setState({ offerCodeValue: event.target.value });
  };
  handleDurationChange = (event) => {
    this.setState({ durationValue: event.target.value });
  };
  checkFields() {
    if (this.state.offerCodeValue == "") {
      let err = {};
      err["offerCodeValue"] = "Please enter the offer code";
      this.setState({ errors: err });
      setTimeout(
        function() {
          this.setState({
            errors: (err["offerCodeValue"] = ""),
          });
          // this.props.history.push("/audiences/viewAudiences");
        }.bind(this),
        3000
      );
    } else {
      if (this.state.durationValue == "") {
        let err = {};
        err["durationValue"] = "Please enter the offer code duration";
        this.setState({ errors: err });
        setTimeout(
          function() {
            this.setState({
              errors: (err["durationValue"] = ""),
            });
            // this.props.history.push("/audiences/viewAudiences");
          }.bind(this),
          3000
        );
      }
    }
    if (this.state.offerCodeValue !== "") {
      if (this.state.durationValue !== "") {
        this.setState({ offerCodeModal: false });
      }
    }
  }
  // ******************************************* Changes made for Goodwill Offer Code End

  // ******************************************* EDIT CURRENT CAMPAIGN: START

  // Handle Edit Campaign
  onEditCurrentCampaign() {
    // Get Selected Campaign
    let selectedCampaign = this.state.allCampaigns
    let currCampaignId = this.state.selectedCampaign
    selectedCampaign = selectedCampaign.filter(function(item) { return item.id === currCampaignId})[0];

    // Update Frontend for Selected Campaign
    this.setState({
      campaignModal: true,
      preclubFlag: selectedCampaign.preclub,
      editCurrentCampaign: true,
      campaignName: selectedCampaign.name,
      campaignDescription: selectedCampaign.description,
      campaignEpochStarts: selectedCampaign.scheduledStart,
      campaignEpochEnds: selectedCampaign.scheduledEnd
    })
  }

  // Handle Front End Configured Date
  // The stored scheduledStart / scheduledEnd epochs are rendered in the user's
  // local timezone. The datetime-local input reads its value as local wall-clock
  // time, and campaignStartDate / campaignEndDate parse it back as local, so
  // formatting in UTC here shifted every fetched campaign by the browser offset.
  configureSeletedDate(time) {
    if(time === undefined || time <= 0 || isNaN(time)) {
      // return new Date(new Date().getTime()).toISOString().split('.')[0].slice(0,-3) # old code commented
      return moment().format("YYYY-MM-DDTHH:mm")
    }
    // return new Date(time * 1000).toISOString().split('.')[0].slice(0,-3) # old code commented 
    return moment.unix(Number(time)).format("YYYY-MM-DDTHH:mm")
  }

  // ******************************************* EDIT CURRENT CAMPAIGN: END

  exportAutomation() {
    // alert("Export Automation Called");
    let exCpif = this.state.selectedTypeInputfields;
    let exCpifFlag = true;
    let exInputFieldObj = {};
    for (let eachexCpIf in exCpif) {
      if ("fieldValue" in exCpif[eachexCpIf]) {
        if (exCpif[eachexCpIf]["fieldValue"] == "") {
          exCpifFlag = false;
        } else {
          exInputFieldObj[exCpif[eachexCpIf]["fieldName"]] =
            exCpif[eachexCpIf]["fieldValue"];
        }
      } else {
        exCpifFlag = false;
      }
    }

    // Check Offer Value 
    if(spendgoOffercode(this.state.localStorageClientId, this.state.selectedChannelId) && !this.state.offerCodeValue) {
      let err = {};
      err["offerCodeValue"] = "Please Enter a SpendGo Campaign ID";
      this.setState({ errors: err });
      setTimeout(
        function() {
          this.setState({
            errors: (err["offerCodeValue"] = ""),
          });
          // this.props.history.push("/audiences/viewAudiences");
        }.bind(this),
        3000
      );
      this.setState({ exportDisable: false });
    }
    else if (this.state.selectedChannelId == "") {
      this.setState({ exportDisable: false });
      this.setState({ error: true });
      setTimeout(
        function() {
          this.setState({
            error: false,
          });
        }.bind(this),
        3000
      );
    } else if (this.state.selectedChannelActionId == "") {
      this.setState({ exportDisable: false });
      this.setState({ channeltypeerror: true });
      setTimeout(
        function() {
          this.setState({
            channeltypeerror: false,
          });
        }.bind(this),
        3000
      );
    } else if (
      this.state.localStorageClientId ===
        "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" &&
      this.state.selectedFriendlyFromOption === ""
    ) {
      this.setState({ friendlyFromOptionError: true });
      setTimeout(
        function() {
          this.setState({
            friendlyFromOptionError: false,
          });
        }.bind(this),
        3000
      );
      this.setState({ exportDisable: false });
    } else if (exCpifFlag == false) {
      this.setState({ exportDisable: false });
      this.setState({ exInputFieldserror: true });
      setTimeout(
        function() {
          this.setState({
            exInputFieldserror: false,
          });
        }.bind(this),
        3000
      );
    } else if (this.state.deploymentName == "") {
      this.setState({ exportDisable: false });
      let err = {};
      err["deploymentName"] = "Please enter Name";
      this.setState({ errors: err });
      setTimeout(
        function() {
          this.setState({
            errors: (err["deploymentName"] = ""),
          });
          // this.props.history.push("/audiences/viewAudiences");
        }.bind(this),
        3000
      );
    } else if (this.state.selectedCampaign == "") {
      this.setState({ exportDisable: false });
      this.setState({ campaignerror: true });
      setTimeout(
        function() {
          this.setState({
            campaignerror: false,
          });
        }.bind(this),
        3000
      );
    } else if (this.state.recurring == false) {
      if (this.state.automationTimestamp == 0) {
        this.setState({ exportDisable: false });
        let err = {};
        err["automationtimestamp"] = "Please select a valid time";
        this.setState({ errors: err });
        setTimeout(
          function() {
            this.setState({
              errors: (err["automationtimestamp"] = ""),
            });
            // this.props.history.push("/audiences/viewAudiences");
          }.bind(this),
          3000
        );
      } else {
        let minimumTimeStamp = Math.round(new Date().getTime() / 1000) + 300;
        if (this.state.automationTimestamp <= minimumTimeStamp) {
          this.setState({ exportDisable: false });
          let err = {};
          err["automationtimestamp"] = "Please select a valid time";
          this.setState({ errors: err });
          setTimeout(
            function() {
              this.setState({
                errors: (err["automationtimestamp"] = ""),
              });
              // this.props.history.push("/audiences/viewAudiences");
            }.bind(this),
            3000
          );
        } else {
          let automationPostObj = this.state.fullAudienceArray;
          (automationPostObj["name"] = this.state.deploymentName),
            (automationPostObj["channelId"] = this.state.selectedChannelId),
            (automationPostObj["channelParameters"] = exInputFieldObj),
            (automationPostObj["campaignId"] = this.state.selectedCampaign),
            (automationPostObj[
              "channelActionId"
            ] = this.state.selectedChannelActionId),
            (automationPostObj["audienceId"] = this.state.selectedAudience),
            (automationPostObj["lastModified"] = Math.round(
              new Date().getTime() / 1000
            )),
            (automationPostObj[
              "scheduledStart"
            ] = this.state.automationTimestamp),
            (automationPostObj["reoccurring"] = this.state.recurring);
          automationPostObj["offerCode"] = this.state.offerCodeValue;
          automationPostObj["offerDuration"] = this.state.durationValue;
          automationPostObj[
            "includeClientSeedList"
          ] = this.state.clientSeedListSwitchStatus;
          automationPostObj[
            "friendlyFrom"
          ] = this.state.selectedFriendlyFromOption;
          fetch(
            "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/automations",
            {
              method: "post",
              body: JSON.stringify(automationPostObj),
            }
          )
            .then((res) => res.json())
            .then((result) => {
              this.setState({ exportDisable: false });
              this.setState({ deploymentModal: false });
              this.fetchAllAutomations();
            });
        }
      }
    } else {
      if (this.state.recurringValue == "") {
        let err = {};
        err["automationtimestamp"] = "Please select a valid recurring time";
        this.setState({ errors: err });
        setTimeout(
          function() {
            this.setState({
              errors: (err["automationtimestamp"] = ""),
            });
            // this.props.history.push("/audiences/viewAudiences");
          }.bind(this),
          3000
        );
        this.setState({ exportDisable: false });
      } else {
        let automationPostObj = this.state.fullAudienceArray;
        (automationPostObj["name"] = this.state.deploymentName),
          (automationPostObj["channelId"] = this.state.selectedChannelId),
          (automationPostObj["channelParameters"] = exInputFieldObj),
          (automationPostObj["campaignId"] = this.state.selectedCampaign),
          (automationPostObj[
            "channelActionId"
          ] = this.state.selectedChannelActionId),
          (automationPostObj["audienceId"] = this.state.selectedAudience),
          (automationPostObj["lastModified"] = Math.round(
            new Date().getTime() / 1000
          )),
          (automationPostObj["recurringCron"] = this.state.recurringValue),
          (automationPostObj["reoccurring"] = this.state.recurring);
        automationPostObj["offerCode"] = this.state.offerCodeValue;
        automationPostObj["offerDuration"] = this.state.durationValue;
        automationPostObj[
          "includeClientSeedList"
        ] = this.state.clientSeedListSwitchStatus;
        automationPostObj[
          "friendlyFrom"
        ] = this.state.selectedFriendlyFromOption;
        fetch(
          "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/automations",
          {
            method: "post",
            body: JSON.stringify(automationPostObj),
          }
        )
          .then((res) => res.json())
          .then((result) => {
            this.setState({ exportDisable: false });
            this.setState({ deploymentModal: false });
            this.fetchAllAutomations();
          });
      }
    }
  }
  saveCampaign() {
    if (this.state.campaignName == "") {
      let err = {};
      err["campaignName"] = "Please enter Campaign Name";
      this.setState({ errors: err });
      setTimeout(
        function() {
          this.setState({
            errors: (err["campaignName"] = ""),
          });
          // this.props.history.push("/audiences/viewAudiences");
        }.bind(this),
        3000
      );
    } else if (this.state.campaignEpochStarts == 0) {
      /*else if(this.state.campaignDescription == '') {
      let err = {}
      err["campaignDescription"] = "Please enter Campaign Description";
      this.setState({ errors: err });
      setTimeout(
        function() {
          this.setState({
            errors: err['campaignDescription'] = ''
          });
          // this.props.history.push("/audiences/viewAudiences");
        }.bind(this),
        3000
      );
    }*/
      let err = {};
      err["campaignStartDate"] = "Please select a valid start date";
      this.setState({ errors: err });
      setTimeout(
        function() {
          this.setState({
            errors: (err["campaignStartDate"] = ""),
          });
          // this.props.history.push("/audiences/viewAudiences");
        }.bind(this),
        3000
      );
    } else if (this.state.campaignEpochEnds == 0) {
      let err = {};
      err["campaignEndDate"] = "Please select a valid end date";
      this.setState({ errors: err });
      setTimeout(
        function() {
          this.setState({
            errors: (err["campaignEndDate"] = ""),
          });
          // this.props.history.push("/audiences/viewAudiences");
        }.bind(this),
        3000
      );
    } else {
      // Selected Campaign Date must start after the automationTimestamp
      if (!this.state.editCurrentCampaign && (this.state.campaignEpochStarts <= this.state.automationTimestamp || this.state.campaignEpochEnds <= this.state.automationTimestamp)) {
        let err = {};
        err["campaignEndDate"] = "Please select a valid date and time";
        this.setState({ errors: err });
        setTimeout(
          function() {
            this.setState({
              errors: (err["campaignEndDate"] = ""),
            });
            // this.props.history.push("/audiences/viewAudiences");
          }.bind(this),
          3000
        );
      } else {
        // Created at date to be stored in the DB inorder to sort the Campaign List based on the created at date
        const createdAt = moment(new Date()).unix();
        // Generate New UUID
        const uuidv4 = require("uuid/v4");
        let campaignuuid = uuidv4();

        // EDIT CAMPAIGN - Over Rides Old Campaign Using Selected Campaign Id
        if(this.state.editCurrentCampaign) { 
          campaignuuid = this.state.selectedCampaign
        }

        let campaignPostObj = {
          id: campaignuuid,
          name: this.state.campaignName,
          description:
            this.state.campaignDescription == ""
              ? " "
              : this.state.campaignDescription,
          clientId: JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("clientId"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ),
          preclub: this.state.preclubFlag,
          scheduledEnd: this.state.campaignEpochEnds,
          scheduledStart: this.state.campaignEpochStarts,
          campaignCreatedAt: createdAt,
        };
        fetch(
          "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/campaigns",
          {
            method: "post",
            body: JSON.stringify(campaignPostObj),
          }
        )
          .then((res) => res.json())
          .then((result) => {
            this.getCampaigns();
            this.setState(resetCampaign);
          });
      }
    }
  }
  handlecampaignChange = (event) => {
    this.setState({ selectedCampaign: event.value });
  };
  handleCronChange = (event) => {
    this.setState({ recurringValue: event });
  };
  getCampaigns() {
    fetch(
      "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/campaigns",
      {
        method: "get",
        headers: {
          clientId: JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("clientId"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ),
        },
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          // if ("Items" in result) {
          //   if (result["Items"].length > 0) {
          //     let allDynamoCampaigns = result["Items"];
          //     let tempCampaignDropdown = [];
          //     for (let eachCampaigns in allDynamoCampaigns) {
          //       let campaignOpt = {};
          //       campaignOpt["label"] =
          //         allDynamoCampaigns[eachCampaigns]["name"];
          //       campaignOpt["value"] = allDynamoCampaigns[eachCampaigns]["id"];
          //       tempCampaignDropdown.push(campaignOpt);
          //     }
          //     this.setState({ campaignDropdown: tempCampaignDropdown });
          //   }
          // }
          if ("Items" in result) {
            if (result["Items"].length > 0) {
              let allDynamoCampaigns = result["Items"];
              let tempCampaignDropdown = [];
              // let epochTimestamps = [];
              // let sortedEpochTimestamps = [];
              // let campaignOpt = {};

              // Save Campaigns
              this.setState({allCampaigns: allDynamoCampaigns})

              for (let eachCampaigns in allDynamoCampaigns) {
                let campaignOpt1 = {};
                if (
                  allDynamoCampaigns[eachCampaigns]["campaignCreatedAt"] !==
                  undefined
                ) {
                  campaignOpt1["label"] =
                    allDynamoCampaigns[eachCampaigns]["name"] +
                    " - Created Date :  " +
                    new Date(
                      allDynamoCampaigns[eachCampaigns]["campaignCreatedAt"] *
                        1000
                    ).toLocaleDateString();
                  campaignOpt1["value"] =
                    allDynamoCampaigns[eachCampaigns]["id"];
                  campaignOpt1["campaignCreatedAt"] =
                    allDynamoCampaigns[eachCampaigns]["campaignCreatedAt"];

                  tempCampaignDropdown.push(campaignOpt1);
                }
              }

              tempCampaignDropdown.sort(
                (a, b) => b.campaignCreatedAt - a.campaignCreatedAt
              );

              for (let eachCampaigns in allDynamoCampaigns) {
                let campaignOpt = {};
                if (
                  allDynamoCampaigns[eachCampaigns]["campaignCreatedAt"] ===
                  undefined
                ) {
                  campaignOpt["label"] =
                    allDynamoCampaigns[eachCampaigns]["name"];
                  campaignOpt["value"] =
                    allDynamoCampaigns[eachCampaigns]["id"];
                  tempCampaignDropdown.push(campaignOpt);
                }
              }
              this.setState({ campaignDropdown: tempCampaignDropdown });
            }
          }
        },
        (error) => {}
      );
  }
  fetchAllAudiences() {
    let path = "/audiences";
    let myInit1 = {
      headers: {
        clientId: JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("clientId"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ),
      },
    };
    API.get(apiName, path, myInit1).then((response) => {
      let audArray = [];
      for (let j in response) {
        let audObj = {};
        audObj["value"] = response[j]["id"];
        audObj["label"] = response[j]["title"];
        audArray.push(audObj);
      }
      this.setState({ audiencesDropDown: audArray });
    });
  }
  fetchAllChannels() {
    let exp_temp = [];
    let clientChannelArray = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("channels"),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    );
    let channelPath = "/channels";
    API.get(apiName, channelPath)
      .then((response) => {
        for (let eachResp in response) {
          if (clientChannelArray.includes(response[eachResp]["id"])) {
            response[eachResp]["display"] = JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("channelsDisObj"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            )[response[eachResp]["id"]];
            exp_temp.push(response[eachResp]);
          }
        }
        let automationArray = [];
        for (let eachExp in exp_temp) {
          if (exp_temp[eachExp]["display"] == true) {
            let automationObj = {};
            automationObj["label"] = exp_temp[eachExp]["program"];
            automationObj["value"] = exp_temp[eachExp]["id"];
            automationArray.push(automationObj);
          }
        }
        this.setState({ automationDropSelection: automationArray });
      })
      .catch((error) => {
        console.log(error.response);
      });
  }
  fetchAllAutomations() {
    fetch(
      "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/automations",
      {
        method: "get",
        headers: {
          clientId: JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("clientId"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ),
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        if ("Items" in result) {
          let automationResponse = result["Items"].sort(
            (a, b) => (a.lastModified < b.lastModified ? 1 : -1)
          );

          fetch(
            "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/campaigns",
            {
              method: "get",
              headers: {
                clientId: JSON.parse(
                  CryptoJS.AES.decrypt(
                    localStorage.getItem("clientId"),
                    process.env.REACT_APP_PASS
                  ).toString(CryptoJS.enc.Utf8)
                ),
              },
            }
          )
            .then((res) => res.json())
            .then(
              (result) => {
                if ("Items" in result) {
                  if (result["Items"].length > 0) {
                    let allDynamoCampaigns = result["Items"];
                    let tempCampaignDropdown = [];
                    for (let eachCampaigns in allDynamoCampaigns) {
                      let campaignOpt = {};
                      campaignOpt["label"] =
                        allDynamoCampaigns[eachCampaigns]["name"];
                      campaignOpt["value"] =
                        allDynamoCampaigns[eachCampaigns]["id"];
                      tempCampaignDropdown.push(campaignOpt);
                    }
                    this.setState({ campaignDropdown: tempCampaignDropdown });
                  }
                  for (let i in automationResponse) {
                    let allCamps = this.state.campaignDropdown.filter(
                      (x) => x.value == automationResponse[i]["campaignId"]
                    )[0];
                    automationResponse[i]["campaignName"] =
                      allCamps !== undefined ? allCamps["label"] : "";
                    automationResponse[i]["lastTriggered"] =
                      "lastTriggered" in automationResponse[i]
                        ? new Date(
                            automationResponse[i]["lastTriggered"] * 1000
                          ).toLocaleDateString() +
                          " " +
                          new Date(
                            automationResponse[i]["lastTriggered"] * 1000
                          ).toLocaleTimeString()
                        : "-";
                    if ("reoccurring" in automationResponse[i]) {
                      if (automationResponse[i]["reoccurring"] == true) {
                        automationResponse[i][
                          "scheduledStart"
                        ] = cronstrue.toString(
                          automationResponse[i]["recurringCron"]
                        );
                      } else {
                        automationResponse[i]["scheduledStart"] =
                          new Date(
                            automationResponse[i]["scheduledStart"] * 1000
                          ).toLocaleDateString() +
                          " " +
                          new Date(
                            automationResponse[i]["scheduledStart"] * 1000
                          ).toLocaleTimeString();
                      }
                    } else {
                      automationResponse[i]["scheduledStart"] =
                        new Date(
                          automationResponse[i]["scheduledStart"] * 1000
                        ).toLocaleDateString() +
                        " " +
                        new Date(
                          automationResponse[i]["scheduledStart"] * 1000
                        ).toLocaleTimeString();
                    }
                    //automationResponse[i]['scheduledStart'] = new Date(automationResponse[i]['scheduledStart'] * 1000).toLocaleDateString() + " " + new Date(automationResponse[i]['scheduledStart'] * 1000).toLocaleTimeString()
                    automationResponse[i]["lastModified"] =
                      new Date(
                        automationResponse[i]["lastModified"] * 1000
                      ).toLocaleDateString() +
                      " " +
                      new Date(
                        automationResponse[i]["lastModified"] * 1000
                      ).toLocaleTimeString();
                    automationResponse[i]["status"] = (
                      <div className="actions-center">
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={automationResponse[i]["active"]}
                              onChange={(event) =>
                                this.setChecked(
                                  event.target.checked,
                                  automationResponse[i]["id"]
                                )
                              }
                            />
                          }
                        />
                      </div>
                    );

                    automationResponse[i]["actions"] = (
                      <div className="actions-right">
                        {automationResponse[i]["channelId"] ===
                          "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91" && (
                          <Tooltip title="Seed List">
                            <Button
                              justIcon
                              style={{ "background-color": "#0014ff" }}
                              onClick={() => {
                                this.setState({
                                  seedListModal: true,
                                  automationId: automationResponse[i]["id"],
                                });
                              }}
                            >
                              <i
                                style={{ fontSize: "14px" }}
                                className={"fa fa-th-list fa-1x"}
                              />
                            </Button>
                          </Tooltip>
                        )}
                        <Tooltip title="Edit">
                          <Button
                            justIcon
                            color="success"
                            onClick={() => {
                              this.fetchAllSendgridTemplates();
                              this.editAutomation(automationResponse[i]["id"]);
                            }}
                          >
                            <i
                              style={{ fontSize: "14px" }}
                              className={"fa fa-edit fa-1x"}
                            />
                          </Button>
                        </Tooltip>
                        <Tooltip title="Delete">
                          <Button
                            justIcon
                            color="danger"
                            onClick={() =>
                              this.warningWithConfirmMessage(
                                automationResponse[i]["id"]
                              )
                            }
                          >
                            <i
                              style={{ fontSize: "14px" }}
                              className={"fa fa-trash fa-1x"}
                            />
                          </Button>
                        </Tooltip>
                      </div>
                    );
                  }
                  this.setState({ automationData: automationResponse });
                  this.setState({ loading: false });
                }
              },
              (error) => {}
            );
        }
      });
  }
  handleChannelChange = (event) => {
    this.setState({ selectedTypeInputfields: [] });
    this.setState({ selectedChannelId: event.value }, () => {
      if (
        this.state.selectedChannelId ===
          "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91" ||
        this.state.selectedChannelId === "2cc3399e-3b2e-49e3-a48c-71367af222f8"
      ) {
        this.setState({
          showOrHideClientSeedListSwitch: "",
        });
      } else {
        this.setState({
          showOrHideClientSeedListSwitch: "none",
        });
      }
    });
    fetch(
      "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/channel-action",
      {
        method: "get",
        headers: { channelId: event.value },
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          if ("Items" in result) {
            if (result["Items"].length > 0) {
              let channelActions = result["Items"];
              let channelOptArray = [];
              for (let eachCA in channelActions) {
                let channelOpt = {};
                channelOpt["label"] = channelActions[eachCA]["name"];
                channelOpt["value"] = channelActions[eachCA]["id"];
                channelOptArray.push(channelOpt);
              }
              this.setState({ channelTypesDropSelection: channelOptArray });
            }
          }
        },
        (error) => {}
      );
  };
  handleAudienceChange = (event) => {
    this.setState({ selectedAudience: event.value });
  };
  handleChannelTypeChange = (event) => {
    this.setState({ selectedChannelActionId: event.value });
    fetch(
      "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/channel-action",
      {
        method: "get",
        headers: { channelId: this.state.selectedChannelId },
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          if ("Items" in result) {
            if (result["Items"].length > 0) {
              let channelActions = result["Items"];
              for (let eachCA in channelActions) {
                if (channelActions[eachCA]["id"] == event.value) {
                  if ("inputFieldsRequired" in channelActions[eachCA]) {
                    this.setState({
                      selectedTypeInputfields:
                        channelActions[eachCA]["inputFieldsRequired"],
                    });
                  }
                }
              }
            }
          }
        },
        (error) => {}
      );
  };
  handleFriendlyFromSelectionChange = (event) => {
    this.setState({ selectedFriendlyFromOption: event.value }, () => {
      console.log(
        "The Selected Friendly From option is : " +
          this.state.selectedFriendlyFromOption
      );
    });
  };
  handleModalInput = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };
  handleselectedTypeInputfields(e, stif) {
    let cpIF = this.state.selectedTypeInputfields;
    for (let eachIf in cpIF) {
      if (cpIF[eachIf]["fieldName"] == stif) {
        cpIF[eachIf]["fieldValue"] = e.target.value;
      }
    }
    this.setState({ selectedTypeInputfields: cpIF });
  }
  RecurringToggleChange(rte) {
    this.setState({ recurring: rte });
    //this.setState({ recurringValue: ""})
  }
  handleTemplateChanges(e, stif) {
    let cpIF = this.state.selectedTypeInputfields;
    for (let eachIf in cpIF) {
      if (cpIF[eachIf]["fieldName"] == stif) {
        cpIF[eachIf]["fieldValue"] = e.value;
      }
    }
    this.setState({ selectedTypeInputfields: cpIF });
  }
  fetchAllSendgridTemplates() {
    fetch(
      "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/sendgrid-templates",
      {
        method: "get",
        headers: {
          clientId: JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("clientId"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ),
        },
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({ allTemplates: result });
        },
        (error) => {
          console.log(error);
        }
      );
  }

  addFilterPlaceholder = () => {
    const filters = document.querySelectorAll("div.rt-th > input");
    for (let filter of filters) {
      filter.placeholder = "Search";
    }
  };

  //function to sort the results
  filterCaseInsensitive = (filter, row) => {
    const id = filter.pivotId || filter.id;
    return row[id] !== undefined
      ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
      : true;
  };

  componentDidMount() {
    this.addFilterPlaceholder();
    this.fetchAllAutomations();
    this.fetchAllAudiences();
    this.fetchAllChannels();

    // ******************************************************************* Changes for Goodwill Offer Code Start
    this.setState({
      localStorageClientId: JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ),
    });
    // ******************************************************************* Changes for Goodwill Offer Code Start
  }
  editAutomation(aid) {
    this.setState({ automationId: aid });
    fetch(
      "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/automations",
      {
        method: "get",
        headers: { id: aid },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        if ("Items" in result) {
          if (result["Items"].length > 0) {
            if ("reoccurring" in result["Items"][0]) {
              if (result["Items"][0]["reoccurring"]) {
                this.setState({
                  recurringValue: result["Items"][0]["recurringCron"],
                });
                this.setState({ recurring: result["Items"][0]["reoccurring"] });
              }
            }
            // Apply Offer Code
            this.setState({offerCodeValue: result["Items"][0]["offerCode"] })
            this.setState({ fullAudienceArray: result["Items"][0] });
            this.setState({
              selectedAudience: result["Items"][0]["audienceId"],
            });
            this.setState(
              {
                selectedChannelId: result["Items"][0]["channelId"],
              },
              () => {
                if (
                  this.state.selectedChannelId ===
                    "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91" ||
                  this.state.selectedChannelId ===
                    "2cc3399e-3b2e-49e3-a48c-71367af222f8"
                ) {
                  this.setState({
                    showOrHideClientSeedListSwitch: "",
                  });
                } else {
                  this.setState({
                    showOrHideClientSeedListSwitch: "none",
                  });
                }
              }
            );
            this.setState({
              selectedChannelActionId: result["Items"][0]["channelActionId"],
            });
            this.setState({ deploymentName: result["Items"][0]["name"] });
            this.setState({
              automationTimestamp: result["Items"][0]["scheduledStart"],
            });
            this.setState({
              selectedCampaign: result["Items"][0]["campaignId"],
            });
            this.setState({
              channelParameters: result["Items"][0]["channelParameters"],
            });
            this.setState({
              clientSeedListSwitchStatus:
                result["Items"][0]["includeClientSeedList"],
            });
            // ******************************************************************* Changes for Goodwill Offer Code Start
            this.setState({ offerCodeValue: result["Items"][0]["offerCode"] });
            this.setState({
              durationValue: result["Items"][0]["offerDuration"],
            });
            // ********************************************************************* Changes For Goodwill Offer Code End
            this.setState({
              selectedFriendlyFromOption: result["Items"][0]["friendlyFrom"],
            });
            fetch(
              "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/channel-action",
              {
                method: "get",
                headers: { channelId: result["Items"][0]["channelId"] },
              }
            )
              .then((res) => res.json())
              .then(
                (result) => {
                  if ("Items" in result) {
                    if (result["Items"].length > 0) {
                      let channelActions = result["Items"];
                      let channelOptArray = [];
                      for (let eachCA in channelActions) {
                        let channelOpt = {};
                        channelOpt["label"] = channelActions[eachCA]["name"];
                        channelOpt["value"] = channelActions[eachCA]["id"];
                        channelOptArray.push(channelOpt);
                      }
                      this.setState({
                        channelTypesDropSelection: channelOptArray,
                      });
                    }
                  }
                },
                (error) => {}
              );
            fetch(
              "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/channel-action",
              {
                method: "get",
                headers: { channelId: result["Items"][0]["channelId"] },
              }
            )
              .then((res) => res.json())
              .then(
                (result) => {
                  if ("Items" in result) {
                    if (result["Items"].length > 0) {
                      let channelActions = result["Items"];
                      for (let eachCA in channelActions) {
                        if (
                          channelActions[eachCA]["id"] ==
                          this.state.selectedChannelActionId
                        ) {
                          if ("inputFieldsRequired" in channelActions[eachCA]) {
                            channelActions[eachCA]["inputFieldsRequired"][0][
                              "fieldValue"
                            ] = this.state.channelParameters[
                              channelActions[eachCA]["inputFieldsRequired"][0][
                                "fieldName"
                              ]
                            ];
                            if (
                              Object.keys(this.state.channelParameters).length >
                              1
                            ) {
                              channelActions[eachCA]["inputFieldsRequired"][1][
                                "fieldValue"
                              ] = this.state.channelParameters[
                                channelActions[eachCA][
                                  "inputFieldsRequired"
                                ][1]["fieldName"]
                              ];
                            }
                            this.setState({
                              selectedTypeInputfields:
                                channelActions[eachCA]["inputFieldsRequired"],
                            });
                          }
                        }
                      }
                    }
                  }
                },
                (error) => {}
              );
            this.getCampaigns();
            this.setState({ deploymentModal: true });
          }
        }
      });
  }
  warningWithConfirmMessage(id) {
    this.setState({
      alert: (
        <SweetAlert
          style={{
            display: "block",
            marginTop: "-100px",
            textTransform: "none",
          }}
          title="Are you sure you want to delete?"
          onConfirm={() => this.successDelete(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
          cancelBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
          confirmBtnText="Yes"
          cancelBtnText="No"
          showCancel
        />
      ),
    });
  }

  successDelete(id) {
    fetch(
      "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/automations",
      {
        method: "delete",
        headers: { id: id },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        this.hideAlert();
        this.fetchAllAutomations();
      });
  }

  render() {
    const { classes } = this.props;
    let showSpinner =
      this.state.loading === true ? (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <div
              style={{ textAlign: "center", marginTop: "20px", width: "100%" }}
            >
              <i
                className="fa fa-spinner fa-spin"
                style={{ fontSize: "50px" }}
              />
            </div>
          </GridItem>
        </GridContainer>
      ) : (
        "No records found"
      );
    return (
      <div className="audiencelistwrap">
        <GridContainer style={{ paddingTop: "1em" }}>
          {this.state.alert}
          <GridItem xs={12} sm={12} md={12} xl={12}>
            <Snackbar
              place="td"
              color={this.state.seedListDeployStatusColor}
              message={this.state.seedListDeployStatusMessage}
              open={this.state.seedListDeployStatus}
              closeNotification={() =>
                this.setState({ seedListDeployStatus: false })
              }
              close
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={3} />
          <GridItem xs={12}>
            <Card>
              <CardHeader color="warning" icon>
                <CardIcon color="warning">
                  <Assignment />
                </CardIcon>
                <h4 style={{ color: "#0c3c54" }}>Automations</h4>
              </CardHeader>
              <CardBody>
                <ReactTable
                  data={this.state.automationData}
                  filterable
                  defaultFilterMethod={(filter, row) =>
                    this.filterCaseInsensitive(filter, row)
                  }
                  columns={[
                    {
                      Header: "Name",
                      accessor: "name",
                    },
                    {
                      Header: "Status",
                      accessor: "status",
                      sortable: false,
                      filterable: false,
                    },
                    {
                      Header: "Campaign",
                      accessor: "campaignName",
                    },
                    {
                      Header: "Last Triggered",
                      accessor: "lastTriggered",
                    },
                    {
                      Header: "Next File Creation Date",
                      accessor: "scheduledStart",
                    },
                    {
                      Header: "Last Modified",
                      accessor: "lastModified",
                    },
                    {
                      Header: "Actions",
                      accessor: "actions",
                      sortable: false,
                      filterable: false,
                    },
                  ]}
                  defaultPageSize={10}
                  //showPaginationTop
                  showPaginationBottom={true}
                  noDataText={showSpinner}
                  className="-striped -highlight"
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        {/* ************************************************************************************* */}
        <center>
          <Dialog
            classes={{
              root: classes.center + " " + classes.modalRoot,
              paper: classes.modal,
            }}
            open={this.state.offerCodeModal}
            TransitionComponent={Transition}
            //keepMounted
            disableBackdropClick
            disableEscapeKeyDown
            onClose={() => this.handleClose("offerCodeModal")}
            aria-labelledby="classic-modal-slide-title"
            aria-describedby="classic-modal-slide-description"
          >
            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{
                backgroundColor: "#92B54B",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
                width: "500px",
              }}
            >
              <h4 className={classes.modalTitle} style={{ color: "#fff" }}>
                <b> Offer Code</b>
              </h4>
            </DialogTitle>
            <DialogContent
              id="classic-modal-slide-description"
              className={classes.modalBody}
            >
              <div>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    {this.state.localStorageClientId ===
                      "2bdbd6af-6cd3-4358-a1a0-437226a20ee9" && (
                      <div>
                        <CustomInput
                          labelText="Offer Code"
                          id="offerCodeValue"
                          // formControlProps={{
                          //   fullWidth: true,
                          // }}
                          inputProps={{
                            value: this.state.offerCodeValue,
                            onChange: (event) =>
                              this.handleOfferCodeChange(event),
                          }}
                        />

                        <br />
                        <span className="redColor">
                          {this.state.errors["offerCodeValue"]}
                        </span>
                      </div>
                    )}

                    <div style={{ paddingLeft: "25px" }}>
                      <CustomInput
                        labelText="Duration"
                        id="durationValue"
                        // formControlProps={{
                        //   fullWidth: true,
                        // }}
                        inputProps={{
                          value: this.state.durationValue,
                          onChange: (event) => this.handleDurationChange(event),
                          style: {
                            width: "80%",
                          },
                        }}
                      />
                      <span>days</span>
                    </div>
                    <br />
                    <span className="redColor">
                      {this.state.errors["durationValue"]}
                    </span>

                    <br />
                  </GridItem>
                </GridContainer>
              </div>
            </DialogContent>
            <DialogActions className={classes.modalFooter}>
              <Button
                onClick={() => this.setState({ offerCodeModal: false })}
                className="btn btncreate"
                color="secondary"
              >
                Cancel
              </Button>
              <Button
                className="btn btncreate"
                color="secondary"
                onClick={() => {
                  this.checkFields();
                }}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </center>
        {/* **************************************************************************************** */}
        <center>
          <Dialog
            classes={{
              root: classes.center + " " + classes.modalRoot,
              paper: classes.modal,
            }}
            open={this.state.deploymentModal}
            TransitionComponent={Transition}
            disableBackdropClick
            disableEscapeKeyDown
            onClose={() => this.setState({ deploymentModal: false })}
            aria-labelledby="classic-modal-slide-title"
            aria-describedby="classic-modal-slide-description"
          >
            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{
                backgroundColor: "#92B54B",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
                width: "800px",
              }}
            >
              <h4 className={classes.modalTitle} style={{ color: "#fff" }}>
                <b>Edit Automation</b>
              </h4>
            </DialogTitle>
            <DialogContent
              id="classic-modal-slide-description"
              className={classes.modalBody}
            >
              <div>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <h4>Audience Name </h4>
                    <Select
                      isDisabled={false}
                      onChange={this.handleAudienceChange}
                      value={
                        this.state.audiencesDropDown.filter(
                          (x) => x.value == this.state.selectedAudience
                        )[0]
                      }
                      options={this.state.audiencesDropDown}
                    />
                    <br />
                    <CustomInput
                      labelText="Automation Name"
                      id="deploymentName"
                      //value={this.state.deploymentName}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        value: this.state.deploymentName,
                        onChange: (event) =>
                          this.handleModalInput(event, "deploymentName"),
                      }}
                    />
                    <span className="redColor">
                      {this.state.errors["deploymentName"]}
                    </span>
                    <h4>Program</h4>
                    <Select
                      // value="CSV"
                      value={
                        this.state.automationDropSelection.filter(
                          (x) => x.value == this.state.selectedChannelId
                        )[0]
                      }
                      onChange={this.handleChannelChange}
                      options={this.state.automationDropSelection}
                    />
                    <span
                      style={{ color: "red", textAlign: "center" }}
                      className={this.state.error ? "block" : "hidden"}
                    >
                      Please select a program
                    </span>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <h4>Channel</h4>
                    <Select
                      // value="CSV"
                      value={
                        this.state.channelTypesDropSelection.filter(
                          (x) => x.value == this.state.selectedChannelActionId
                        )[0]
                      }
                      onChange={this.handleChannelTypeChange}
                      options={this.state.channelTypesDropSelection}
                      styles={{
                        // Fixes the overlapping problem of the component
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                      }}
                    />
                    <span
                      style={{ color: "red", textAlign: "center" }}
                      className={
                        this.state.channeltypeerror ? "block" : "hidden"
                      }
                    >
                      Please select a channel
                    </span>
                  </GridItem>
                  {this.state.localStorageClientId ===
                    "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" && (
                    <GridItem xs={12} sm={12} md={12}>
                      <h4>Friendly From</h4>
                      <Select
                        // value={this.state.selectedFriendlyFromOption}
                        value={
                          this.state.friendlyFromDropdownSelection.filter(
                            (x) =>
                              x.value == this.state.selectedFriendlyFromOption
                          )[0]
                        }
                        onChange={this.handleFriendlyFromSelectionChange}
                        options={this.state.friendlyFromDropdownSelection}
                        styles={{
                          // Fixes the overlapping problem of the component
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                      />
                      <span
                        style={{ color: "red", textAlign: "center" }}
                        className={
                          this.state.friendlyFromOptionError
                            ? "block"
                            : "hidden"
                        }
                      >
                        Please select a friendly from option
                      </span>
                    </GridItem>
                  )}
                  {/* ********************************************************************** */}
                  {this.state.localStorageClientId ===
                    "2bdbd6af-6cd3-4358-a1a0-437226a20ee9" && (
                    <GridItem xs={12} sm={12} md={12}>
                      <Button
                        color="secondary"
                        onClick={() => this.setState({ offerCodeModal: true })}
                      >
                        Offer Code
                      </Button>
                    </GridItem>
                  )}
                  {/* ********************************************************************** */}
                  <GridItem
                    style={{ marginLeft: "5em", marginRight: "5em" }}
                    xs={12}
                    sm={12}
                    md={12}
                  >
                    <div style={{ paddingLeft: "5em", paddingRight: "5em" }}>
                      {this.state.selectedTypeInputfields.map(
                        (stif, idx) =>
                          stif.type == "string" ? (
                            <CustomInput
                              labelText={stif.labelName}
                              id={stif.fieldName}
                              formControlProps={{
                                fullWidth: true,
                              }}
                              inputProps={{
                                value: stif.fieldValue,
                                onChange: (event) =>
                                  this.handleselectedTypeInputfields(
                                    event,
                                    stif.fieldName
                                  ),
                              }}
                            />
                          ) : (
                            <Select
                              value={
                                this.state.allTemplates.filter(
                                  (x) => x.value == stif.fieldValue
                                )[0]
                              }
                              onChange={(event) =>
                                this.handleTemplateChanges(
                                  event,
                                  stif.fieldName
                                )
                              }
                              options={this.state.allTemplates}
                              styles={{
                                // Fixes the overlapping problem of the component
                                menu: (provided) => ({
                                  ...provided,
                                  zIndex: 9999,
                                }),
                              }}
                            />
                          )
                      )}
                      <span
                        style={{ color: "red", textAlign: "center" }}
                        className={
                          this.state.exInputFieldserror ? "block" : "hidden"
                        }
                      >
                        Please fill all fields
                      </span>
                      <br />
                      <br />
                      <form className={classes.container} noValidate>
                        <TextField
                          isValidDate={dateValid}
                          id="datetime-local"
                          label="Action date"
                          type="datetime-local"
                          //defaultValue="2017-05-24T10:30"
                          className={classes.textField}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={
                            Datetime.moment(
                              new Date(
                                this.state.automationTimestamp * 1000
                              ).toLocaleDateString()
                            ).format("YYYY-MM-DD") +
                            "T" +
                            new Date(this.state.automationTimestamp * 1000)
                              .getHours()
                              .toLocaleString("en-US", {
                                minimumIntegerDigits: 2,
                                useGrouping: false,
                              }) +
                            ":" +
                            new Date(this.state.automationTimestamp * 1000)
                              .getMinutes()
                              .toLocaleString("en-US", {
                                minimumIntegerDigits: 2,
                                useGrouping: false,
                              })
                          }
                          onChange={this.deploymentDate.bind(this)}
                        />
                      </form>
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.recurring}
                            onChange={(event) =>
                              this.RecurringToggleChange(event.target.checked)
                            }
                          />
                        }
                        label="Recurring"
                      />
                      <span className="redColor">
                        {this.state.errors["automationtimestamp"]}
                      </span>
                      <br />
                      {this.state.recurring ? (
                        <CronBuilder
                          cronExpression={this.state.recurringValue}
                          onChange={this.handleCronChange}
                          showResult={true}
                          style={{ backgroundColor: "#ffffff" }}
                        />
                      ) : (
                        ""
                      )}
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={this.state.clientSeedListSwitchStatus}
                            onChange={(event) =>
                              this.switchClientSeedListStatus(
                                event.target.checked
                              )
                            }
                          />
                        }
                        label="Include Client Seed List"
                        style={{
                          display: this.state.showOrHideClientSeedListSwitch,
                        }}
                      />
                      <h4>Campaign</h4>
                      <Select
                        // value="CSV"
                        value={
                          this.state.campaignDropdown.filter(
                            (x) => x.value == this.state.selectedCampaign
                          )[0]
                        }
                        onChange={this.handlecampaignChange}
                        options={this.state.campaignDropdown}
                      />
                      <Button
                        onClick={() =>
                          this.setState({
                            campaignModal: true,
                            preclubFlag: false,
                          })
                        }
                        className="btn btncreate"
                        color="secondary"
                      >
                        Create Campaign
                      </Button>
                      <Button
                        onClick={() => {this.onEditCurrentCampaign()}
                      }
                        className="btn btncreate"
                        color="secondary"
                      >
                        Edit Current Campaign
                      </Button>
                      <span
                        style={{ color: "red", textAlign: "center" }}
                        className={
                          this.state.campaignerror ? "block" : "hidden"
                        }
                      >
                        Please Select a campaign
                      </span>
                    </div>
                  </GridItem>
                  {spendgoOffercode(this.state.localStorageClientId, this.state.selectedChannelId) && (
                      <GridItem
                        xs={12}
                        sm={12}
                        md={12}
                      >
                        <CustomInput
                          labelText="SpendGo Campaign ID"
                          id="offerCodeValue"
                          inputProps={{
							              value: this.state.offerCodeValue,
                            onChange: (event) =>
                              this.handleOfferCodeChange(
                                event
                              ),
                          }}
                        />
                        <br />
                        <span className="redColor">
                          {
                            this.state.errors[
                            "offerCodeValue"
                            ]
                          }
                        </span>
                      </GridItem>
                    )}
                </GridContainer>
              </div>
            </DialogContent>
            <DialogActions className={classes.modalFooter}>
              <Button
                onClick={() => this.handleClose("deploymentModal")}
                className="btn btncreate"
                color="secondary"
              >
                Cancel
              </Button>
              <Button
                className="btn btncreate"
                color="secondary"
                onClick={() => {
                  this.setState({ exportDisable: true });
                  this.exportAutomation();
                }}
                disabled={this.state.exportDisable}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </center>
        {/* // Seed List Popup Start */}
        <center>
          <Dialog
            classes={{
              root: classes.center + " " + classes.modalRoot,
              paper: classes.modal,
            }}
            open={this.state.seedListModal}
            TransitionComponent={Transition}
            disableBackdropClick
            disableEscapeKeyDown
            onClose={() => this.setState({ seedListModal: false })}
            aria-labelledby="classic-modal-slide-title"
            aria-describedby="classic-modal-slide-description"
          >
            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{
                backgroundColor: "#92B54B",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
                width: "800px",
              }}
            >
              <h4 className={classes.modalTitle} style={{ color: "#fff" }}>
                <b>Perform Seed List Execution</b>
              </h4>
            </DialogTitle>
            <DialogContent
              id="classic-modal-slide-description"
              className={classes.modalBody}
            >
              <div>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <LoadingOverlay
                      active={this.state.seedListDeploySummary}
                      spinner
                      text="Deploying Seed List"
                    >
                      <h4>Seed List Name </h4>
                      <Select
                        isDisabled={false}
                        onChange={this.handleSeedListOptionsChange}
                        value={this.state.seedListSelectedOptionsArray}
                        options={this.state.seedListOptionsArray}
                        isMulti={true}
                      />
                      <span className="redColor">
                        {this.state.errors["selectSeedList"]}
                      </span>
                      <CustomInput
                        labelText="Audience Segment (Optional)"
                        id="audienceSegment"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          onChange: (event) =>
                            this.handleAudienceSegmentInputChange(event),
                        }}
                      />
                      {/* <span className="redColor">
                      {this.state.errors["deploymentName"]}
                    </span> */}
                      <CustomInput
                        labelText="Single Email Address (Optional)"
                        id="singleEmailAddress"
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          onChange: (event) =>
                            this.handleSingleEmailAddressInputChange(event),
                        }}
                      />
                      {/* <span className="redColor">
                      {this.state.errors["deploymentName"]}
                    </span> */}
                      <br />
                    </LoadingOverlay>
                  </GridItem>
                </GridContainer>
              </div>
            </DialogContent>
            <DialogActions className={classes.modalFooter}>
              <Button
                onClick={() => {
                  this.handleClose("seedListModal");
                  this.resetClientSeedListModalFields();
                }}
                className="btn btncreate"
                color="secondary"
              >
                Cancel
              </Button>
              <Button
                className="btn btncreate"
                color="secondary"
                onClick={() => {
                  this.deploySeedListOptions();
                }}
              >
                Deploy
              </Button>
            </DialogActions>
          </Dialog>
        </center>
        {/* // Seed List Popup End */}
        <center>
          <Dialog
            classes={{
              root: classes.center + " " + classes.modalRoot,
              paper: classes.modal,
            }}
            open={this.state.campaignModal}
            TransitionComponent={Transition}
            //keepMounted
            disableBackdropClick
            disableEscapeKeyDown
            onClose={() => this.handleClose("campaignModal")}
            aria-labelledby="classic-modal-slide-title"
            aria-describedby="classic-modal-slide-description"
          >
            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{
                backgroundColor: "#92B54B",
                borderTopLeftRadius: "6px",
                borderTopRightRadius: "6px",
                width: "800px",
              }}
            >
              <h4 className={classes.modalTitle} style={{ color: "#fff" }}>
                <b> {this.state.editCurrentCampaign?"Edit Campaign":"Create Campaign"}</b>
              </h4>
            </DialogTitle>
            <DialogContent
              id="classic-modal-slide-description"
              className={classes.modalBody}
            >
              <div>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText="Campaign Name"
                      id="campaignName"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        onChange: (event) =>
                          this.handleModalInput(event, "campaignName"),
                        value: this.state.campaignName,
                      }}
                    />
                    <span className="redColor">
                      {this.state.errors["campaignName"]}
                    </span>
                    <br />
                    <CustomInput
                      labelText="Campaign Description"
                      id="campaignDescription"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        onChange: (event) =>
                          this.handleModalInput(event, "campaignDescription"),
                          value: this.state.campaignDescription,
                      }}
                    />
                    <span className="redColor">
                      {this.state.errors["campaignDescription"]}
                    </span>
                    <br />
                    <FormControlLabel
                      control={
                        <Switch
                          color="primary"
                          checked={this.state.preclubFlag}
                          onChange={(event) =>
                            this.togglePreclubFlagStatus(event.target.checked)
                          }
                        />
                      }
                      label="Guest Connect"
                    />
                    <br />
                    <form className={classes.container} noValidate>
                      <TextField
                        // isValidDate={dateValid}
                        id="datetime-local"
                        label="Start Date"
                        type="datetime-local"
                        defaultValue={this.configureSeletedDate(this.state.campaignEpochStarts)}
                        className={classes.textField}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={this.campaignStartDate.bind(this)}
                      />
                    </form>
                    <span className="redColor">
                      {this.state.errors["campaignStartDate"]}
                      {this.state.campaignStartDateErrorText}
                    </span>
                    <br />
                    <form className={classes.container} noValidate>
                      <TextField
                        // isValidDate={dateValid}
                        id="datetime-local"
                        label="End Date"
                        type="datetime-local"
                        defaultValue={this.configureSeletedDate(this.state.campaignEpochEnds)}
                        className={classes.textField}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={this.campaignEndDate.bind(this)}
                      />
                    </form>
                    <span className="redColor">
                      {this.state.errors["campaignEndDate"]}
                      {this.state.campaignEndDateErrorText}
                    </span>
                    <br />
                  </GridItem>
                  {["8c001fde-3728-48dc-9950-b8480ca9fbee",
                  "83da098f-2fc7-4b98-8455-c08f9aceb4ed",
                  "3fe7e557-16f5-406c-bbc8-887fdec7ba8b",
                  "7203dd51-f88b-4a4b-877c-92326d027915",
                  "cf6144d2-bb68-43b6-9876-dbf620b57c21"].includes(this.state.localStorageClientId) &&
                  ["3b3e90db-f06b-4ba4-9fbb-769637647ab0",
                  "25c7cb9a-a192-46f5-b32d-49e8d52afea8",
                  "92ec41c7-6724-4891-bc17-24981a3261dd",
                  "c2a842ba-36cc-46b7-8fa4-3a361708b34b",
                  "g786cb0f-eecc-4b87-adef-34eb20f3f766",
                  "88adbfaa-0fc0-49af-a745-d97cb1b4bda7",
                  "1d337d2d-e23a-445a-bda6-2405dbb79dcc",
                  "f786cb0f-eecc-4b87-adef-34eb20f3f766",
                  "33bc71b1-4495-43f0-ab64-17ed38270e04",
                  "3c8a9cf7-a0b2-4845-8436-d598181e6d78"].includes(this.state.selectedChannelId)
                && (
                  <GridItem
                    xs={12}
                    sm={12}
                    md={12}
                  >
                    <CustomInput
                      labelText="SpendGo Campaign ID"
                      id="offerCodeValue"
                      inputProps={{
                        value: this.state.offerCodeValue,
                        onChange: (event) =>
                          this.handleOfferCodeChange(
                            event
                          ),
                      }}
                    />
                    <br />
                    <span className="redColor">
                      {
                        this.state.errors[
                        "offerCodeValue"
                        ]
                      }
                    </span>
                  </GridItem>
                )}
                </GridContainer>
              </div>
            </DialogContent>
            <DialogActions className={classes.modalFooter}>
              <Button
                onClick={() => this.setState(resetCampaign)}
                className="btn btncreate"
                color="secondary"
              >
                Cancel
              </Button>
              <Button
                className="btn btncreate"
                color="secondary"
                onClick={() => {
                  if(this.state.campaignStartDateErrorText === '' && this.state.campaignEndDateErrorText === '') {
                    this.saveCampaign();
                  }
                }}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </center>
      </div>
    );
  }
}
ViewAutomations.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(notificationsStyle)(ViewAutomations);



// WEBPACK FOOTER //
// ./src/views/Automations/ViewAutomations.jsx